import request from '@/utils/request'
export function userinfo(data){
    return request({
        url:'api/users/'+data,
        method: 'get',
    })
}
// /api/customer/wxSocial 客户授权登录
export function wxSocial(data){
    return request({
        url:'api/customer/wxSocial' ,
        method: 'post',
        data
    })
}
// 新增客户访问记录
export function readRecord(data){
    localStorage.setItem('key3',1)
    return request({
        url:'api/readRecord' ,
        method: 'post',
        data
    })
}
// /api/readRecord/queryNumbers/{userId} 访问人数
export function queryNumbers(data){
    return request({
        url:'api/readRecord/queryNumbers/'+data,
        method: 'get',
    })
}
// 微信config
export function getJsApiTicket(params){
    return request({
        url:'wechat/getJsApiTicket',
        method: 'get',
        params
    })
}